<template>
  <div class="gallery-tiles">
    <!-- Placeholder section -->
    <template v-if="!images.length">
      <div class="photo-grid photo-grid_placeholder">
        <div class="photo-grid__primary">
          <div class="photo-grid__main">
            <div class="photo-grid__main-cell">
              <div class="photo-grid__image-placeholder"></div>
            </div>
          </div>
          <div class="photo-grid__side">
            <div
              class="photo-grid__side-cell"
              v-for="(tile, idx) in 2"
              :key="idx + 1"
            >
              <div class="photo-grid__image-placeholder"></div>
            </div>
          </div>
        </div>
        <div class="photo-grid__thumbnails">
          <div
            class="photo-grid__thumb-cell"
            v-for="(tile, idx) in 4"
            :key="idx + 3"
          >
            <div class="photo-grid__image-placeholder"></div>
          </div>
        </div>
      </div>
    </template>
    <!-- With images section -->
    <template v-if="images.length">
      <div ref="photoGrid" class="photo-grid">
        <div class="photo-grid__primary">
          <div class="photo-grid__main">
            <div class="photo-grid__main-cell">
              <div class="photo-grid__image">
                <img
                  @click="openSelectedInLightbox"
                  @load="hideLoader"
                  @error="onImageError"
                  :src="getImage(0)"
                  :data-image-index="0"
                  alt=""
                />
                <span class="image-loader">
                  <loading-spinner :size="24" />
                </span>
              </div>
            </div>
          </div>
          <div class="photo-grid__side">
            <div
              class="photo-grid__side-cell"
              v-for="(image, idx) in numOfSideImages()"
              :key="idx + 1"
            >
              <div class="photo-grid__image">
                <img
                  @click="openSelectedInLightbox"
                  @load="hideLoader"
                  @error="onImageError"
                  :src="getImage(idx + 1)"
                  :data-image-index="idx + 1"
                  alt=""
                />
                <span class="image-loader">
                  <loading-spinner :size="24" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="photo-grid__thumbnails" v-if="images.length > 4">
          <template v-for="(image, idx) in 4">
            <div
              class="photo-grid__thumb-cell"
              :key="idx + 3"
              v-if="getImage(idx + 3) != null"
            >
              <template v-if="images.length > 7 && idx + 3 == 6">
                <span class="photo-grid__more" @click="openAllInLightbox"
                  >+ {{ getImagesCount() }}</span
                >
              </template>
              <div class="photo-grid__image">
                <img
                  @click="openSelectedInLightbox"
                  @load="hideLoader"
                  @error="onImageError"
                  :src="getImage(idx + 3)"
                  :data-image-index="idx + 3"
                  alt=""
                />
                <span class="image-loader">
                  <loading-spinner :size="24" />
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <T1GalleryLightbox
      @clicked="closeLightbox"
      v-if="isOpen"
      :startSlideIndex="startSlideIndex"
      :slides="images"
      :objectName="objectName"
      :category="category"
    />
  </div>
</template>

<script>
import T1GalleryLightbox from "./T1GalleryLightbox";

export default {
  name: "gallery-tiles",
  components: {
    T1GalleryLightbox
  },
  props: {
    images: Array,
    objectName: String,
    category: String
  },
  data: () => ({
    isOpen: false,
    startSlideIndex: 0,
    defaultImage: "https://www.travelone.pl/newimgs/zaslepka_lato.jpg"
  }),
  methods: {
    hideLoader(e) {
      const loaderElem = e.target.nextElementSibling;
      loaderElem.classList.add("_hiding");

      setTimeout(() => {
        loaderElem.remove();
      }, 150);
    },
    onImageError(e) {
      e.target.src = this.defaultImage;
      this.hideLoader;
    },
    getImage(idx) {
      let imagesArr = [];
      this.images.forEach(obj => {
        imagesArr.push(obj.txt);
      });
      return imagesArr[idx];
    },
    numOfSideImages() {
      let numberOfImages = this.images.length;
      if (numberOfImages == 2) {
        return 1;
      } else if (numberOfImages == 3 || numberOfImages >= 5) {
        return 2;
      } else if (numberOfImages == 4) {
        return 3;
      }
    },
    openAllInLightbox() {
      if (this.images.length) {
        this.startSlideIndex = 0;
        this.isOpen = true;
      }
    },
    openSelectedInLightbox(e) {
      let imageIdx = e.target.getAttribute("data-image-index");
      this.startSlideIndex = imageIdx;
      this.isOpen = true;
    },
    closeLightbox(val) {
      this.isOpen = val;
    },
    getImagesCount() {
      let otherImagesCount = this.images.length - 6;

      if (otherImagesCount == 1) {
        return otherImagesCount + " zdjęcie";
      } else if (otherImagesCount >= 2 && otherImagesCount <= 4) {
        return otherImagesCount + " zdjęcia";
      } else {
        return otherImagesCount + " zdjęć";
      }
    },
    addProperClasses() {
      const photoGrid = this.$refs.photoGrid;
      let numberOfImages = this.images.length;
      if (numberOfImages == 1) {
        photoGrid.classList.add("photo-grid_no-sidebar");
      } else if (numberOfImages >= 2 && numberOfImages <= 4) {
        photoGrid.classList.add("photo-grid_with-sidebar");
      } else if (numberOfImages >= 5) {
        photoGrid.classList.add("photo-grid_full-view");
      }
    }
  },
  mounted() {
    this.addProperClasses();
  },
  updated() {
    this.addProperClasses();
  }
};
</script>

<style lang="scss" scoped>
.gallery-tiles {
  overflow: hidden;

  @media (max-width: $screen-xs-max) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.photo-grid {
  $self: &;
  overflow: hidden;
  margin-left: -5px;
  margin-right: -5px;

  &__primary {
    display: flex;
  }

  &__main {
    height: 100%;
    padding-left: 5px;
    padding-right: 5px;

    &-cell {
      width: 100%;
      height: 100%;
    }
  }

  &__more {
    background-color: rgba(darken($blue-medium, 10%), 0.85);
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 5px;
    bottom: 0;
    left: 5px;
    transition: background-color 0.2s ease-in-out;
    z-index: 1;

    &:hover {
      background-color: rgba(darken($blue-medium, 15%), 0.9);
    }
  }

  &__image {
    background-color: $gray-00;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    opacity: 1;
    overflow: hidden;
    width: 100%;
    height: 100%;
    transition: opacity 0.2s ease-in-out;

    &:hover {
      opacity: 0.9;
    }

    > img {
      display: block;
      width: 101%;
      height: auto;
      min-height: 100%;
      object-fit: cover;
      position: absolute;
      backface-visibility: hidden;
      transform: translateZ(0);
    }
  }

  &__image-placeholder {
    background-color: $gray-00;
    border-radius: 2px;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  &_no-sidebar,
  &_with-sidebar {
    #{ $self } {
      &__primary {
        height: 50vw;
        max-height: 440px;

        @media (min-width: $screen-md) {
          height: 400px;
          max-height: none;
        }

        @media (min-width: $screen-lg) {
          height: 460px;
        }
      }
    }
  }

  &_no-sidebar {
    #{ $self } {
      &__main {
        width: 100%;
      }
    }
  }

  &_with-sidebar,
  &_full-view,
  &_placeholder {
    #{ $self } {
      &__side {
        display: flex;
        flex-direction: column;
        width: 30%;
        height: 100%;
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }

  &_with-sidebar {
    #{ $self } {
      &__main {
        width: 70%;
      }

      &__side {
        &-cell {
          width: 100%;
          flex: 1 1 auto;

          &:not(:last-of-type) {
            padding-bottom: 10px;
          }
        }
      }
    }
  }

  &_full-view,
  &_placeholder {
    #{ $self } {
      &__primary {
        height: 360px;

        @media (min-width: $screen-md) {
          height: 340px;
        }

        @media (min-width: $screen-lg) {
          height: 380px;
        }
      }

      &__main {
        width: 70%;
        padding-bottom: 10px;
      }

      &__side {
        &-cell {
          width: 100%;
          height: 50%;
          padding-bottom: 10px;
        }
      }

      &__thumbnails {
        display: flex;
        height: 120px;

        @media (min-width: $screen-md) {
          height: 120px;
        }

        @media (min-width: $screen-lg) {
          height: 140px;
        }
      }

      &__thumb-cell {
        flex: 1 1 auto;
        height: 100%;
        padding-left: 5px;
        padding-right: 5px;
        position: relative;
      }
    }
  }
}

.image-loader {
  background-color: $gray-00;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  transition: opacity 0.2s ease-in-out;

  &._hiding {
    opacity: 0;
  }
}
</style>
